import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import getShopId from '@core/reducers/shop/selectors/getShopId';
import trackSwimlaneClicked from '@results/tracking/actions/trackSwimlaneClicked';

import SwimlaneCardContainer from './SwimlaneCardContainer';

const mapStateToProps = createStructuredSelector({
  shopId: getShopId,
});

const mapDispatchToProps = {
  trackSwimlaneClicked,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SwimlaneCardContainer);
